import { DataContract } from '@advsol/core';
import { IdentityData } from './identityData';
import { GenericPropertyDataCollection } from './genericPropertyDataCollection';
/**
 * A party represents any sort of business organization or person.
 */
export class GenericEntityData extends DataContract {
  /**
   * The DataType must be \"Asi.Soa.Membership.DataContracts.PartyData, Asi.Contracts\"
   */
  $type = 'Asi.Soa.Core.DataContracts.GenericEntityData, Asi.Contracts';

  EntityTypeName: string;
  PrimaryParentEntityTypeName: string = "Party";
  PrimaryParentIdentity: IdentityData;
  Identity: IdentityData;
  Properties: GenericPropertyDataCollection;

}
